export const CheckboxProps = {
  modelValue: Boolean,
};
